import { trim } from 'lodash';
import { mixed, object, string } from 'yup';

import { ScheduleRangeType } from '../../../../../data/data/schedule/enums';
import { messages } from '../../../../../data/utils/form.utils';

export const schema = object()
  .shape({
    healthProfessionalId: string()
      .transform(trim)
      .required(messages.required.id)
      .default(''),
    rangeType: mixed<ScheduleRangeType>()
      .oneOf(Object.values(ScheduleRangeType))
      .required(messages.required.id)
      .default(ScheduleRangeType.SINGLE),
    startDate: string()
      .transform(trim)
      .required(messages.required.id)
      .default(null)
      .nullable(),
    endDate: string().transform(trim).default(null).nullable(),
  })
  .required()
  .noUnknown();
